import { decodeJwt } from 'jose';

import type { TokenPayload } from '../../../../front/src/types/auth';

/**
 * ⛔ Ce service DÉCODE, il ne SIGNE pas.
 *
 * `genNativeIdentityToken` vivait ici jusqu'au 2026-09-21 : elle signait un JWT
 * HS256 dans le navigateur, avec le secret d'identité native. Signer côté client
 * impose de publier le secret — et le bundle client public de graphdebate le
 * publiait bel et bien (fuite du 21/09). Un jeton que n'importe quel visiteur
 * peut forger n'authentifie rien.
 *
 * L'api reconnaît désormais l'app native au drapeau `X-Native-App`
 * (`api/src/utils/nativeApp.js`), déjà posé par `useCapacitor` derrière
 * `Capacitor.isNativePlatform()`. Aucune signature côté client.
 *
 * ⛔ Ne pas réintroduire de signature ici : tout secret qui remonte dans ce
 * fichier repart dans le bundle public. ⚠ Ne pas y écrire non plus le NOM d'un
 * secret, même en commentaire — la source map embarque le texte source et le
 * garde-fou CI la scanne aussi.
 */
export class JWTService {
  static decode<T = TokenPayload>(token: string): T {
    try {
      return decodeJwt<T>(token);
    } catch (error) {
      throw new Error(
        `[JWTService.decode] Error decoding token: ${
          error instanceof Error ? error.message : String(error)
        }`,
      );
    }
  }
}
